const colors = {
  // Logo/Brand
  green: '#3A685C',
  darkGreen: '#335049',
  lightGreen: '#93AEA7',
  gray: '#313B3F',
  darkGray: '#222428',

  // UI/Background
  lightBg: '#F7F9FB', // Main app background
  paper: '#FFFFFF',    // Card/form background
  lightGray: '#E5E7EB', // Table rows, dividers

  // Accent/Status
  accent: '#FFE38E',   // Gold accent
  error: '#B00020',    // Error
  success: '#3A685C',  // Success (same as green)

  // Text
  textPrimary: '#222428', // Main text
  textSecondary: '#313B3F', // Secondary text
};

export default colors; 